const shallowDiff = (prev, next) => {
  for (let attribute in prev) {
    if (!(attribute in next)) {
      return true
    }
  }
  for (let attribute in next) {
    if (prev[attribute] !== next[attribute]) {
      return true
    }
  }
  return false
}

/**
 * Modified areEqual compare for "memo" function for "react-window"
 *
 * @link https://github.com/bvaughn/react-window/blob/master/src/areEqual.js
 *
 * @usage React.memo(MyComponent, areEqual)
 * @param {Object} prevProps
 * @param {Object} nextProps
 * @returns {Boolean}
 */
export const areEqual = (prevProps, nextProps) => {
  const { style: prevStyle, isScrolling: prevIsScrolling, ...prevRest } = prevProps
  const { style: nextStyle, isScrolling: nextIsScrolling, ...nextRest } = nextProps

  return (
    !shallowDiff(prevStyle, nextStyle) &&
    !shallowDiff(prevRest, nextRest) &&
    (nextIsScrolling === prevIsScrolling || nextIsScrolling)
  )
}
